import {
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  PipeTransform,
  ViewChild,
} from '@angular/core';
import { IxExcelColumn, IxExcelService, IxValidationMessagePipe } from 'ix-ng-wijmo';
import {
  IxNgComponentsModule,
  IxNgComValidationService,
  IxNgHtmlStaticUtils,
  PRIORITY_VALIDATION,
} from 'ix-ng-components';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { Router } from '@angular/router';
import { IxNgFormsStaticUtils, IxNgValidationService, IxValidationRecord } from 'ix-ng-forms';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { ValidationDialogService } from './validation-dialog.service';
import { getMessageColor, getMessageType } from '../validation-shared';
import { NgClass } from '@angular/common';
import { Button } from 'primeng/button';

@Component({
  selector: 'lib-validation-dialog',
  templateUrl: './validation-dialog.component.html',
  providers: [IxExcelService],
  imports: [NgClass, Dialog, Button, IxNgComponentsModule],
})
export class ValidationDialogComponent implements OnInit, OnDestroy {
  PRIORITY_VALIDATION_DIALOG: number = PRIORITY_VALIDATION;
  public multiSortMeta: { field: string; order: number }[];
  public title = 'Sporočila';
  public searchValue = '';
  @ViewChild('dt')
  public dt?: Table;
  formats: { keys: string[]; formater: PipeTransform; args?: string[] }[] = [];
  private _dialogIxNotification?: Dialog;

  private router = inject(Router);
  public ixExcelService = inject(IxExcelService);
  protected ixNgValidationService = inject(IxNgValidationService);
  private ixNgComValidationService = inject(IxNgComValidationService);
  protected validationDialogService = inject(ValidationDialogService);

  @ViewChild('btnZapri', { read: ElementRef })
  public btnZapri?: ElementRef<HTMLButtonElement>;

  @ViewChild('dialogIxNotification')
  public get dialogIxNotification(): Dialog | undefined {
    return this._dialogIxNotification;
  }

  public set dialogIxNotification(value: Dialog) {
    this._dialogIxNotification = value;
  }

  public get display(): boolean {
    return true;
  }

  public set display(value: boolean) {
    this.ixNgComValidationService.appComValidationOpen = true;
  }

  constructor() {
    this.multiSortMeta = [];
    this.formats = [{ keys: ['type'], formater: new IxValidationMessagePipe() }];
  }

  ngOnInit() {
    if (
      this.ixNgValidationService &&
      this.ixNgValidationService.validationRecordList.length === 0
    ) {
      // ComValidationDialogComponent.toggleNavigation(this.router, false /*forceShow*/);
      this.ixNgComValidationService.appComValidationOpen = false;
    }
    setTimeout(() => {
      if (this.btnZapri && this.ixNgValidationService?.validationRecordIgnoreAction === undefined) {
        this.btnZapri.nativeElement.focus();
      }
    }, 100);
  }

  public hide(event: Event, ignoreAction?: boolean) {
    if (this.ixNgValidationService) {
      const validationRecordOnCloseRedirectUrl =
        this.ixNgValidationService.validationRecordOnCloseRedirectUrl;
      this.ixNgValidationService.updateNotification(
        [],
        undefined,
        undefined,
        this.ixNgValidationService.validationRecordOnCloseAction,
      );
      // ComValidationDialogComponent.toggleNavigation(this.router, false);
      this.ixNgComValidationService.appComValidationOpen = false;
      this.ixNgValidationService.appIxNotificationOpen = false;
      if (this.ixNgValidationService.validationRecordOnCloseAction) {
        this.ixNgValidationService.validationRecordOnCloseAction();
      }
      if (validationRecordOnCloseRedirectUrl) {
        setTimeout(() => {
          this.router.navigateByUrl(validationRecordOnCloseRedirectUrl);
        }, 0);
      }
      if (this.validationDialogService.validationRecordOnCloseCustomAction && !ignoreAction) {
        this.validationDialogService.validationRecordOnCloseCustomAction();
      }
    }
  }

  public ignore(event: Event) {
    if (this.ixNgValidationService?.validationRecordIgnoreAction) {
      const ignoreAction: () => void = this.ixNgValidationService.validationRecordIgnoreAction;
      // validationRecordOnCloseAction ne resetiramo saj želimo ohraniti bind-ano funkcionalnost
      // this.ixFrameworkService.validationRecordOnCloseAction = undefined; // validationRecordOnCloseAction se kliče samo ko kliknemo gumb Zapri
      this.hide(event, true);
      ignoreAction();
    }
  }

  exportToExcel() {
    this.title = `Seznam_napak_${moment().format('D-MM-YYYY')}`;
    const properties: XLSX.FullProperties = {
      Title: this.title,
      Subject: 'Sporočila',
      Author: 'MOPE',
      CreatedDate: new Date(),
    };

    const workBook = this.ixExcelService.createWorkBook(properties);
    const columSeznam: IxExcelColumn<IxValidationRecord>[] = [];
    if (this.ixNgValidationService?.validationRecordList) {
      columSeznam.push(new IxExcelColumn('uiGroupName', 'Oznaka', 25));
      columSeznam.push(new IxExcelColumn('type', 'Tip', 10));
      columSeznam.push(new IxExcelColumn('code', 'Koda', 10));
      columSeznam.push(new IxExcelColumn('errorMessage', 'Sporočilo', 100));
      this.ixExcelService.createWorkSheet<IxValidationRecord>(
        workBook,
        this.ixNgValidationService.validationRecordList,
        columSeznam,
        'Sporočila',
      );
      this.ixExcelService.saveFile(workBook, `${this.title}.xlsx`);
    }
  }

  /** Metoda za filtriranje na klientu s pomočjo primeng */
  tableFilterChanged(vals: {
    event: Event | undefined;
    value: unknown[] | null;
    field: string;
    type: string;
  }) {
    if (this.dt) {
      this.dt.filter(vals.value, vals.field, vals.type);
    }
  }

  onTableSearch(ke: KeyboardEvent) {
    const keyword = (ke.target as HTMLInputElement).value;
    this.searchValue = keyword.trim();
    if (this.dt) {
      this.dt.filterGlobal(keyword, 'contains');
    }
  }

  searchFunction(): (row: IxValidationRecord, searchValue: string) => boolean {
    return (row: IxValidationRecord, searchValue: string) =>
      IxNgFormsStaticUtils.searchFunction(searchValue, row.code) ||
      IxNgFormsStaticUtils.searchFunction(searchValue, row.errorMessage);
  }

  getFormater(key: string): { pipe: PipeTransform; args: string[] } | undefined {
    const format = this.formats.find((f) => f.keys.indexOf(key) >= 0);
    if (format) {
      return { pipe: format.formater, args: format.args || [] };
    }
    return;
  }

  errorCount() {
    let errorCount = 0;
    const validRecord = this.ixNgValidationService.validationRecordList;
    if (validRecord.length > 0) {
      for (const item of validRecord) {
        if (item.type.toString() === 'ERROR') {
          errorCount++;
        }
      }
    }
    return errorCount;
  }

  warningCount() {
    let warningCount = 0;
    const validRecord = this.ixNgValidationService.validationRecordList;
    if (validRecord.length > 0) {
      for (const item of validRecord) {
        if (item.type.toString() === 'WARNING') {
          warningCount++;
        }
      }
    }
    return warningCount;
  }

  tempValidationRecordList(): IxValidationRecord[] {
    // TODO: To je tako grdo da je treba nujno popravit v frameworku
    return this.ixNgValidationService?.validationRecordList;
  }

  showGroupName(row: IxValidationRecord | undefined, rowIndex: number) {
    return (
      (rowIndex === 0 ||
        row?.uiGroupName !==
          this.ixNgValidationService?.validationRecordList[rowIndex - 1].uiGroupName) &&
      row?.uiGroupName !== undefined &&
      row?.uiGroupName?.trim().length > 0
    );
  }

  ngOnDestroy(): void {
    this.validationDialogService.showPrezriOpozorilaButton = true;
  }

  protected readonly getMessageType = getMessageType;
  protected readonly getMessageColor = getMessageColor;
  protected readonly IxNgHtmlStaticUtils = IxNgHtmlStaticUtils;
}
